// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "vendor" + "." + "e9ce74f2" + ".chunk.css";
};